<template>
  <div class="ra">
    <div :class="['ra-sidebar', { open: navOpen }]">
      <div v-if="!navOpen" class="ra-sidebar__logo">
        <img
          :src="getImage('logo-icon.png')"
          :class="'icon fadeIn'"
          alt="R"
          @click="openNav"
        />
        <span class="ra-beta">Beta</span>
      </div>
      <template v-if="navOpen">
        <div class="ra-sidebar__logo fadeIn">
          <img :src="getImage('logo.png')" alt="R" />
          <span class="ra-beta">Beta</span>
        </div>
        <div class="ra-sidebar__user fadeIn">
          <div class="user">
            <ra-avatar
              :size="28"
              :shape="'rounded'"
              :name="userName"
              :background="'#ccc'"
            />
            <div>
              <p>{{ userName }}</p>
              <span>{{ userEmail }}</span>
            </div>
          </div>
        </div>
        <div class="ra-sidebar__menu fadeIn">
          <el-menu
            :default-active="activeMenu"
            :router="true"
            @select="navOpen = false"
          >
            <template v-for="(route, index) in radiusRoutes">
              <el-menu-item
                v-if="route.activeRoute"
                :id="`ra-item-${route.name}`"
                :key="index"
                :index="route.name"
                :route="{ name: `${route.name}.index` }"
              >
                <i :class="`ra-icon--${route.icon}`"></i>
                <span>{{ route.label }}</span>
              </el-menu-item>
            </template>
            <div class="ra-sidebar__menu-group">
              <p>Products</p>
              <el-menu-item
                v-for="(route, index) in productsRoutes"
                :id="`ra-item-${route.name}`"
                :key="index"
                :index="route.route"
                :disabled="!route.activeRoute"
                :route="{ name: `${route.route}` }"
              >
                <i :class="`ra-icon--${route.icon}`"></i>
                <span>{{ route.label }}</span>
              </el-menu-item>
            </div>
            <div class="ra-sidebar__menu-logout">
              <el-menu-item @click="logout">
                <i class="ra-icon--log-out"></i>
                <span>Logout</span>
              </el-menu-item>
            </div>
          </el-menu>
        </div>
      </template>
      <div class="ra-sidebar__toggler">
        <span @click="navOpen = !navOpen">
          <i :class="`ra-icon--arrow-${!navOpen ? 'right' : 'left'}`"></i>
        </span>
      </div>
    </div>
    <div class="ra-overlay" @click="navOpen = false"></div>
    <div
      class="ra-dashboard--body"
      :style="{ padding: !childLayout ? '30px' : '' }"
    >
      <template v-if="childLayout">
        <component :is="`${childLayout}-layout`" />
      </template>
      <el-container v-else>
        <ra-breadcrumb :routes="breadcrumbRoutes" />
        <slot />
      </el-container>
      <fund-wallet-cta v-if="showFundWalletCTA" />
    </div>
  </div>
</template>

<script>
import { userCan } from "@/lib/utils";
import * as actions from "@/store/action-types";

import FundWalletCta from "@/components/Wallet/FundWalletCta.vue";

import ProductLayout from "@/layouts/product.vue";
import AuthxAppLayout from "@/layouts/authx-app.vue";

export default {
  name: "AppLayout",
  components: {
    ProductLayout,
    AuthxAppLayout,
    FundWalletCta
  },
  data() {
    return {
      navOpen: false,
      activeMenu: "home",
      activeKlsCount: 0
    };
  },
  computed: {
    breadcrumbRoutes() {
      const { matched } = this.$route;
      let routes = matched.map(route => {
        return {
          path: route.path || null,
          label: route.meta.label
        };
      });
      if (!this.$route.name.includes("home")) {
        routes.splice(0, 0, {
          path: "/home",
          label: "Home"
        });
      }
      return routes;
    },

    radiusRoutes() {
      return [
        {
          icon: "home",
          label: "Home",
          name: "home",
          activeRoute: true
        },
        {
          icon: "list",
          label: "Organisation",
          name: "organisation",
          activeRoute: true
        },
        {
          icon: "credit-card",
          label: "Transactions",
          name: "transactions",
          activeRoute: true
        },
        {
          icon: "code",
          label: "Developers",
          name: "developers",
          activeRoute: true
        },
        {
          icon: "settings",
          label: "Settings",
          name: "settings",
          activeRoute: true
        }
      ];
    },

    productsRoutes() {
      return [
        {
          icon: "check-circle",
          label: "Verify Identity",
          name: "verify-identity",
          route: "verify-identity.index",
          activeRoute: true
        },
        {
          icon: "lock",
          label: "AuthX",
          name: "authx",
          route: "authx.index",
          activeRoute: true
        }
      ];
    },

    userName() {
      const { user } = this.$store.getters.user;
      return `${user.first_name} ${user.last_name.charAt(0)}.`;
    },

    userEmail() {
      const { user } = this.$store.getters.user;
      return user && user.email;
    },

    childLayout() {
      return this.$route.meta.childLayout;
    },

    showFundWalletCTA() {
      return (
        !this.$route.path.includes("home") &&
        userCan("payment", "payment.init", true)
      );
    },

    walletBalance() {
      return this.$store.getters.wallet.balance;
    },

    organisation() {
      return this.or
    }
  },
  mounted() {
    if (this.$route.name !== null) {
      this.activeMenu = this.$route.name.split(".")[0];
    }
    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 100) {
        document.querySelector(".ra-page--header").classList.add("minimize");
      } else {
        document.querySelector(".ra-page--header").classList.remove("minimize");
      }
    });

    this.initializeUsersnap();
  },
  watch: {
    $route() {
      if (this.$route.name !== null) {
        this.activeMenu = this.$route.name.split(".")[0];
      }
    }
  },
  methods: {
    initializeUsersnap() {
      const USERSNAP_GLOBAL_API_KEY = "07748ec8-7fa5-453a-a726-a8cfef092097";
      const { email, id } = this.$store.getters.user.user;

      window.onUsersnapCXLoad = api => {
        api.init({
          user: {
            userId: id,
            email: email
          }
        });
      };
      const script = document.createElement("script");
      script.defer = 1;
      script.src = `https://widget.usersnap.com/global/load/${USERSNAP_GLOBAL_API_KEY}?onload=onUsersnapCXLoad`;
      document.getElementsByTagName("head")[0].appendChild(script);
    },

    openNav() {
      const organisation = this.$store.getters.organisation.summary;

      if (organisation) {
        this.navOpen = true;
      }
    },

    logout() {
      this.$store.dispatch(actions.LOGOUT).then(() => {
        this.$router.push({ name: "login" });
      });
    }
  }
};
</script>

<style lang="scss">
.ra {
  height: 100vh;
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;

  .ra-sidebar {
    position: absolute;
    width: 50px;
    height: 100%;
    background: var(--ra-parent-sidebar);
    padding: 20px 11px;
    z-index: 5;
    transition: width 0.3s ease-in;

    &__logo {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      img {
        height: 32px;
        width: auto;
        margin-bottom: 10px;

        &.icon {
          height: 28px;
          cursor: pointer;
        }
      }

      .ra-beta {
        display: inline-block;
        background: transparent;
        color: #fff;
        border-radius: 4px;
        font-size: 9px;
        font-weight: 600;
        text-transform: uppercase;
      }
    }

    &__user {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 50px 0 20px;
      padding-left: 5px;

      .user {
        display: flex;
        align-items: center;

        div:first-child {
          margin-right: 10px;
        }

        div:last-child {
          display: flex;
          flex-direction: column;
        }

        p,
        span {
          color: #fff;
          font-size: 0.75rem;
          line-height: 1;
        }

        p {
          margin-bottom: 5px;
        }

        span {
          opacity: 0.5;
          display: inline-block;
          width: 95%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      i {
        font-size: 12px;
        color: #ffffff;
      }
    }

    &__menu {
      background: transparent;

      .el-menu {
        width: 100%;
        border: none;
        background: none;
        margin-top: 50px;
        position: relative;
        overflow: hidden;

        .el-menu-item {
          background: transparent;
          color: #ffffff;
          display: flex;
          align-items: center;
          font-size: 0.725rem;
          font-weight: 400;
          opacity: 0.8;
          border-radius: 6px;
          padding: 8px 12px !important;
          height: 34px;
          transition: all 0.3s ease-in-out;

          span {
            margin-left: 12px;
            transition: opacity 0.3s ease-in-out;
          }

          i {
            font-size: 13px;
            color: #ffffff;
          }

          &.is-active {
            background: var(--ra-app-sidebar);
            opacity: 1;

            i {
              color: #ffffff !important;
            }
          }

          &:hover:not(.is-active) {
            opacity: 0.8;
          }

          &.is-disabled {
            opacity: 0.25 !important;
          }
        }
      }

      &-group {
        margin: 30px 0 20px;

        p {
          font-size: 0.65rem;
          text-transform: uppercase;
          color: #ffffff;
          margin-left: 12px;
          margin-bottom: 10px;
        }
      }

      &-logout {
        margin-top: 40px;
      }
    }

    &__toggler {
      position: absolute;
      right: 11px;
      bottom: 30px;
      cursor: pointer;

      span {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 28px;
        width: 28px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.08);

        i {
          font-size: 10px;
          color: #ffffff;
        }
      }
    }

    &.open {
      width: 220px;
      left: 0;
      z-index: 10;
      transition: all 0.25s ease-in;

      .ra-sidebar__logo {
        flex-direction: row;

        img {
          margin-bottom: 0;
          margin-right: 7px;
        }

        .ra-beta {
          margin-top: 8px;
        }
      }

      + .ra-overlay {
        opacity: 1;
        z-index: 3;
        transition: opacity 0.4s ease-out;
      }

      ~ .ra-dashboard--body {
        margin-left: 10px !important;
        transition: all 0.4s ease-out;
      }
    }
  }

  .ra-overlay {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: -1;
    opacity: 0;
    transition: opacity 0.4s ease-in;
  }

  .ra-dashboard--body {
    width: calc(100% - 50px);
    margin-left: 48px;
    height: 100vh;
    overflow: hidden;
    overflow-y: scroll;
    background: #f5f5f5;
    position: relative;
    transition: all 0.4s ease-out;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.25s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

@media (max-width: 1024px) {
}

@media (max-width: 600px) {
}
</style>
